import { render, staticRenderFns } from "./CreateAuditoriaModal.vue?vue&type=template&id=caf74fbc"
import script from "./CreateAuditoriaModal.vue?vue&type=script&lang=js"
export * from "./CreateAuditoriaModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports